// extracted by mini-css-extract-plugin
export default {"statusContainer":"StatusBadge_statusContainer__jabeF","statusBadge":"StatusBadge_statusBadge__k6AzU","soft":"StatusBadge_soft__YURZ8","dot":"StatusBadge_dot__rJIjT"};